import { type ApolloError } from '@apollo/client';
import { useSnackbar } from 'notistack';

export function useCommonApolloOptions() {
  const { enqueueSnackbar } = useSnackbar();

  return {
    onError: (error: ApolloError) => {
      enqueueSnackbar(error.message, { variant: 'error' });
    },
  };
}
